import { Generator } from 'shared/utils/models';

const TYPE = 'assignedAccountGroups';
export default new Generator(TYPE).createSystemListModel();
